/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/MailOption.ts
 * @create:      2018-08-30 16:08:45.227
 * @modify:      2022-06-26 08:08:08.103
 * @version:     4.1.0
 * @times:       8
 * @lines:       70
 * @copyright:   Copyright © 2018-2022 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * @since 1.0.5
 * @version 2022-06-26
 */
export class MailOption {
    public From: string;

    public To: string;

    public Subject?: string;

    public Text?: string;

    public HTML?: string;

    /**
     *
     * @param from
     * @param to
     * @param subject
     * @param text
     * @param html
     */
    public constructor(
        from: string,
        to: string,
        subject?: string,
        text?: string,
        html?: string,
    ) {
        this.From = from;
        this.To = to;
        this.Subject = subject;
        this.Text = text;
        this.HTML = html;
    }
}
